import assert from 'assert';

import BenchlingConfig from 'BenchlingConfig';
import {RowModelContext} from 'notebook/tables/store/contexts/RowModelContext';
import {RowModel} from 'notebook/tables/store/models/RowModel';

export function useRowModel(): RowModel;
export function useRowModel<T>(subSelector: (rowModel: RowModel) => T): T | null;
export function useRowModel<T>(subSelector?: (rowModel: RowModel) => T): T | null {
  const {rowModelSelector, useTableEditableStore} = RowModelContext.useContext();
  return useTableEditableStore((store) => {
    if (!BenchlingConfig.ELN_TABLE_ENABLE_STATE_SELECTORS) {
      return null;
    }
    const rowModel = rowModelSelector(store);
    assert(rowModel, `RowModel not found`);
    if (!subSelector) {
      return rowModel as T;
    }
    return subSelector(rowModel);
  });
}
